import { InteractionBubbles } from '@hse-design/core';

//

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=288%3A1
 * @storybook /?path=/story/badge-badgelabel--playground
 * @react /src-components-badge-label
 * @reactStorybook /?path=/story/badge-badgelabel--playground
 */
var script = {
  name: 'HseBadgeLabel',
  props: {
    /**
     * Компонент
     */
    component: {
      type: [String, Object],
      default: 'span'
    },
    /**
     * Размер компонента
     * @values smallX, small, medium
     */
    size: {
      type: String,
      validator: v => ['smallX', 'small', 'medium'].includes(v),
      default: 'small'
    },
    /**
     * Отключенное состояние
     */
    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Состояние ховера
     */
    hover: {
      type: Boolean,
      default: false
    },
    /**
     * Состояние фокуса
     */
    focused: {
      type: Boolean,
      default: false
    },
    /**
     * Выбранный лейбл
     */
    selected: {
      type: Boolean,
      default: false
    },
    /**
     * Вариант отображения
     */
    variant: {
      type: String,
      validator: v => ['outlined', 'filled'].includes(v),
      default: 'filled'
    },
    /**
     * Переключатель кликабельности
     */
    clickable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      interactionBubbles: this.clickable ? InteractionBubbles.create() : undefined
    };
  },
  mounted() {
    this.bubblesUpdate();
  },
  updated() {
    this.bubblesUpdate();
  },
  methods: {
    bubblesUpdate() {
      if (this.clickable && !this.interactionBubbles) {
        this.interactionBubbles = InteractionBubbles.create();
      }
      if (this.interactionBubbles) {
        this.interactionBubbles.update({
          root: this.$refs.bubbleRoot,
          enabled: this.clickable && !this.disabled
        });
      }
    },
    onMouseDown(e) {
      if (this.interactionBubbles) this.interactionBubbles.onMouseDown();
      /**
       * @type {MouseEvent}
       */
      this.$emit('mousedown', e);
    },
    onKeyDown(e) {
      if (this.interactionBubbles) this.interactionBubbles.onKeyDown(e);
      /**
       * @type {KeyboardEvent}
       */
      this.$emit('keydown', e);
    }
  },
  computed: {
    listeners() {
      return {
        keydown: this.onKeyDown,
        mousedown: this.onMouseDown,
        ...this.$listeners
      }
    }
  }
};

export default script;
